import PraisoServices from "./PraisoServices";
import { getToken } from "./LocalStorageService";

export const AdminGetUserAPI = async (userId: number) => {
  const ApiUrl = `users/${userId}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminGetUserRoleAPI = async (params?: any) => {
  const ApiUrl = `user-role/search`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...params,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminGetGroupHierarchyAPI = async (loggedInUserId) => {
  const ApiUrl = `groups/v1/get-group-hierarchy/${loggedInUserId}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminUpsertUserApi = async (userData) => {
  window.localStorage.removeItem("API");
  const ApiUrl = `users`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        ...userData,
      },
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminGetUser = async (userId) => {
  const data = await AdminGetUserAPI(userId);
  return data;
};

export const adminGetUserRole = async () => {
  let data = await AdminGetUserRoleAPI();
  return data;
  // data = {
  //   status: {
  //     code: 0,
  //     message: "Success",
  //   },
  //   content: [
  //     {
  //       roleId: 3,
  //       roleTitle: "Company Admin",
  //       isEnabled: true,
  //       roleDescription:
  //         "A company admin can view, add and update your organisation settings and manage users.",
  //     },
  //     {
  //       roleId: 5,
  //       roleTitle: "Guest",
  //       isEnabled: true,
  //       roleDescription:
  //         "A Guest user can only view information and cannot add or update organisation or user details",
  //     },
  //     {
  //       roleId: 6,
  //       roleTitle: "Driver",
  //       isEnabled: false,
  //       roleDescription:
  //         "Drivers appear on the wall of legends, receive content from Praiso and are managed by integration. ",
  //     },
  //   ],
  // };
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const adminGetGroupHierarchy = async (loggedInUserId) => {
  const data = await AdminGetGroupHierarchyAPI(loggedInUserId);
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const adminUpsertUser = async (userData) => {
  const data = await AdminUpsertUserApi(userData);
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
  return data;
};

export const AdminGetDriverNotesAPI = async (userId: string, params) => {
  let ApiUrl = `users/driver-notes/${userId}`;
  if (params.impersonationid)
    ApiUrl = `users/driver-notes/${userId}?impersonationId=${params.impersonationid}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminGetDriverNotes = async (userId: string, params) => {
  const data = await AdminGetDriverNotesAPI(userId, params);
  return data;
};

export const AdminUpsertDriverNoteAPI = async (noteObj) => {
  window.localStorage.removeItem("API");
  const ApiUrl = `admin/drivernote/upsert`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        ...noteObj,
      },
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminUpsertDriverNote = async (noteObj) => {
  const data = await AdminUpsertDriverNoteAPI(noteObj);
  return data;
};

export const AdminUpdateNoteReadStatusAPI = async (noteId) => {
  window.localStorage.removeItem("API");
  const ApiUrl = `users/driver-note/${noteId}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminUpdateNoteReadStatus = async (noteId) => {
  const data = await AdminUpdateNoteReadStatusAPI(noteId);
  return data;
};